import { makeImpl } from "../hashSet.js";
/** @internal */
export function keySet(self) {
  return makeImpl(self);
}
//# sourceMappingURL=keySet.js.map